import * as turf from '@turf/turf';
import { NavigateFunction } from 'react-router-dom';
import AgoToast from '../../../../components/Toast/AgoToast';
import { clearData } from '../../../../redux/actions/map-actions/map-action';
import { IProducer } from '../../../producer-list/interfaces';
import { Feature } from '@turf/helpers';

export function formatDate(date: Date | string) {
  if (!date) return '';
  const formater = Intl.DateTimeFormat(undefined, {
    timeZone: 'UTC',
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
  return formater.format(new Date(date));
}

export function addDays(date: Date, days: number) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function navigateBackToProfile(journeyId: string, navigate: NavigateFunction, dispatch: any) {
  dispatch(clearData());
  navigate(`/leads/${journeyId}`);
}

export function showToast(title: string, message: string, type: any, toastId: string) {
  //todo: change this on refactor
  AgoToast.showToast({ title, message, type, toastId });
}

export function getPaddedBBox(bbox: turf.helpers.BBox) {
  const bboxPolygon = turf.bboxPolygon(bbox);
  const paddedPolygon = turf.transformScale(bboxPolygon, 2);
  return turf.bbox(paddedPolygon);
}

export function getRandomNumber(): number {
  const array = new Uint32Array(1);
  window?.crypto?.getRandomValues(array);
  return array[0];
}

export function allowBoundaryEditAndDelete(shouldLdAllowBoundaryEdit: boolean, producersWithGroups: IProducer[], journeyId?: string) {
  if (!journeyId || !producersWithGroups?.length) return false;
  if (shouldLdAllowBoundaryEdit) return true;

  return !producersWithGroups?.find((producer) => producer.journeyId === journeyId)?.fieldGroups?.length;
}

const getEmailFromUpdatedStamp = (stamp: string) => {
  if (!stamp) {
    return 'Unknown';
  }
  const stampSegments = stamp.split('|');
  return stampSegments[stampSegments.length - 1] || '';
};

export function getLatestUpdatedDate(fields: Feature[]) {
  const hasSavedFields = fields.some((f: Feature) => f.properties?.createdAt);
  if (!hasSavedFields) return null;

  return fields.reduce(
    (currentLatestUpdatedInfo: any, field) => {
      const properties = field.properties;
      const fieldUpdatedAt = new Date(properties?.updatedAt ?? properties?.createdAt);
      const currentUpdatedAt = currentLatestUpdatedInfo?.updatedAt || null;
      if (currentUpdatedAt === null || fieldUpdatedAt > currentUpdatedAt) {
        return {
          updatedBy: getEmailFromUpdatedStamp(properties?.updatedBy ?? properties?.createdBy),
          updatedAt: fieldUpdatedAt,
        };
      }
      return currentLatestUpdatedInfo;
    },
    { updatedBy: getEmailFromUpdatedStamp(fields[0].properties?.updatedBy), updatedAt: null },
  );
}
